import moment from 'moment';
import { IEventItem } from '../../../../store/player/events/store';

export const filters = [
  {
    callback: (e: IEventItem) => moment().diff(moment(e.start, 'YYYY-MM-DD').startOf('day')) < 0,
    label: 'UPCOMING'
  },
  {
    callback: (e: IEventItem) => moment().diff(moment(e.end, 'YYYY-MM-DD').endOf('day')) > 0,
    label: 'COMPLETED'
  }
];
